import { API, API_GET_ID } from "../../../Config";

export const GetSingleChallenge = (id) => {
  return API_GET_ID(API.SingleChallenge, id);
};
